import React, { useEffect, useRef } from 'react';
import { animate, useInView } from 'framer-motion';
interface CountUpProps {
  /** Valor final, admite prefijos y sufijos: "100+", "4.9★", "24h". */
  value: string;
  className?: string;
  duration?: number;
}

/**
 * Cuenta hasta el valor final escribiendo directo en el DOM (sin re-renders),
 * para que la animación no bloquee el hilo principal.
 */
export function CountUp({
  value,
  className,
  duration = 1.4
}: CountUpProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.6
  });
  const match = value.match(/^([^\d]*)([\d.,]+)(.*)$/);
  useEffect(() => {
    const element = ref.current;
    if (!inView || !match || !element) return;
    const prefix = match[1];
    const suffix = match[3];
    const target = Number(match[2].replace(',', '.'));
    const decimals = match[2].includes('.') ? 1 : 0;
    const controls = animate(0, target, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: latest => {
        element.textContent = `${prefix}${latest.toFixed(decimals)}${suffix}`;
      }
    });
    return () => controls.stop();
  }, [inView, match, duration]);
  const initial = match ? `${match[1]}${0 .toFixed(match[2].includes('.') ? 1 : 0)}${match[3]}` : value;
  return <span ref={ref} className={className} data-id="element-182" data-mp="1vilxtcdfmtjf">
      {initial}
    </span>;
}